// src/components/PWAUpdater.js
import React, { useState, useEffect } from 'react';
import { Workbox } from 'workbox-window';

const PWAUpdater = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [updateInfo, setUpdateInfo] = useState(null);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      const wb = new Workbox('/service-worker.js');

      // Escuchar cuando hay una nueva versión instalada y esperando
      wb.addEventListener('waiting', (event) => {
        setUpdateInfo(wb);
        setShowUpdate(true);
      });

      // También escuchar cuando se instala por primera vez o se actualiza
      wb.addEventListener('installed', (event) => {
        if (event.isUpdate) {
          setUpdateInfo(wb);
          setShowUpdate(true);
        }
      });

      wb.register();
    }
  }, []);

  const handleUpdate = () => {
    if (updateInfo) {
      // Enviar mensaje al service worker para que tome el control
      updateInfo.messageSkipWaiting();
      setShowUpdate(false);
      // Recargar para usar la nueva versión
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    setShowUpdate(false);
  };

  if (!showUpdate) return null;

  return (
    <div className="pwa-update-prompt">
      <p>✨ ¡Nueva versión de KREAMUN disponible!</p>
      <div className="update-buttons">
        <button onClick={handleUpdate} className="btn-update">
          Actualizar ahora
        </button>
        <button onClick={handleDismiss} className="btn-dismiss">
          Más tarde
        </button>
      </div>
    </div>
  );
};

export default PWAUpdater;